/* src/components/library-mgmt/library-mgmt.component.scss */
:host .spacing {
  margin-bottom: 1.5rem;
}
:host .category-col--nr {
  width: 2rem;
}
:host .category-col--subject {
  white-space: normal;
  width: 25rem;
}
:host .category-col--cause {
  max-width: 100px;
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
:host .category-col--active {
  width: 1px;
  white-space: nowrap;
  pointer-events: none;
  tab-index: -1;
}
:host .category-col--active .active-checkbox {
  padding-left: 10px;
}
:host .category-col--options {
  width: 1px;
  white-space: nowrap;
}
/*# sourceMappingURL=library-mgmt.component-CBR6GBM5.css.map */
